import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Header from '../layouts/Header';
import Breadcrumb from '../layouts/Breadcrumb';
import Footer from '../layouts/Footer';
import Content from '../sections/accounttypes/Content';
import { t } from 'i18next';


class Accounttypes extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>{t("londonbank")} | {t("account types")}</title>
                    <meta
                        name="description"
                        content={t("londonbank_description")}
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{ pagename: t("account types") }} />
                <Content />
                <Footer />
            </Fragment>
        );
    }
}

export default Accounttypes;